













































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class KebutuhanEdukasiSection extends Vue {
  @Prop({ default: () => ({}) }) readonly value!: any;
  @Prop({ default: false }) readonly disabled!: boolean;

  form: any = {
    pendidikan: "sma",
    kemampuan_kognitif: "tidak_ada",
    kognitif_ket: "",
    motivasi_edukasi: "tidak_ada",
    motivasi_ket: "",
    keterbatasan_fisik: "tidak_ada",
    fisik_ket: "",
    kebutuhan_penerjemah: false
  };

  pendidikanOptions = [
    { text: "Tidak Sekolah", value: "tidak_sekolah" },
    { text: "SD", value: "sd" },
    { text: "SMP", value: "smp" },
    { text: "SMA", value: "sma" },
    { text: "Diploma", value: "diploma" },
    { text: "S1", value: "s1" },
    { text: "S2", value: "s2" },
    { text: "S3", value: "s3" }
  ];

  created() {
    if (this.value && typeof this.value === "object") {
      this.form = { ...this.form, ...this.value };
    }
  }


  @Watch("form", { deep: true })
  onFormChange(val: any) { this.$emit("input", { ...val }); }

  syncFromValue(val: any) {
    if (!val) return;
    this.form = { ...this.form, ...val };
  }
}
